<template>
  <div class="box" :class="{'osOrAndroid':osOrAndriod}">
      <div class="container">
      <!-- 游戏名称 -->
      <div class="tittle">
          <!-- <span class="back" @click="back">返回上一页</span> -->
          <span class="name">{{fromData.gameName}}</span>
      </div>
      <!-- 游戏介绍 -->
      <div class="game_introduce" v-if="fromData.contentDesc">
         <div class="introduce_title">游戏介绍</div>
         <div class="introduce_content">{{fromData.contentDesc}}</div>
      </div>
      <!-- 游戏福利 -->
      <div class="game_welfare" v-if="JSON.stringify(fromData.welfareTag) !== '[]' ">
           <div class="welfare_title">游戏福利</div>
         <div class="welfare_content" >
             <div v-for="(item,index) in fromData.welfareTag" :key="index">{{item.name}}、</div>
         </div>
      </div>
        <!-- 游戏类型 -->
      <div class="game_type" v-if="JSON.stringify(fromData.types)!== '[]' " >
           <div class="type_title">游戏类型</div>
         <div class="type_content" >
             <div v-for="(item,index) in fromData.types"  :key="index">{{item}}、</div>
         </div>
      </div>
        <!-- 游戏大小 -->
      <div class="game_size" v-if="fromData.gameSize">
           <div class="size_title">游戏包大小</div>
         <div class="size_content">{{fromData.gameSize}}</div>
      </div>
        <!-- 专属福利 -->
      <div class="game_exclusive" v-if="fromData.titleDesc && fromData.productDesc">
           <div class="exclusive_title" v-if="fromData.titleDesc" >{{fromData.titleDesc}}</div>
           <div class="exclusive_content" v-if="fromData.productDesc">
             <p>{{fromData.productDesc}}</p>
         </div>
      </div>
        <!-- 游戏图标 -->
      <div class="game_icon" v-if="fromData.iconUrl">
           <div class="icon_title">游戏图标</div>
         <div class="icon_content">
             <img :src="fromData.iconUrl" alt="">
         </div>
      </div>
        <!-- 游戏视频 -->
      <div class="game_video" v-if="fromData.coverUrl">
           <div class="video_title">游戏视频</div>
         <div class="video_content">
             <div>
                <video  autoplay="autoplay" controls="controls" ref='audio'></video>
             </div>
             
         </div>
      </div>
        <!-- 游戏截图-->
      <div class="game_screenshot" v-if="fromData.resourceUrlList">
           <div class="screenshot_title">游戏截图</div>
         <div class="screenshot_content">
            <ul>
                <li v-for="(item,index) in fromData.resourceUrlList" :key="index">
                    <img :src="item" alt="">
                </li>
            </ul>
         </div>
      </div>
      
  </div>
  </div>
</template>

<script>
import {getGameDetail} from '@/api/detail.js'
export default {
    data() {
        return {
          fromData:'',
          osOrAndriod:false
        }
    },
    created() {
        this.init()
        // 根据不同的设备，添加样式
        if(this.osroan()==2){
            this.osOrAndriod=true
        }else{
            this.osOrAndriod=false

        }


    },
    methods: {
        // 获取地址栏参数
        init(){
              this.location = window.location.href
              function getQueryString(name) {
              const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
              const urlObj = window.location;
              var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
              if (r != null) return unescape(r[2]); return '';
         }
         let id = getQueryString('productId')

         this.getList(id)
        },
        // 获取数据
        getList(id){
             getGameDetail(id).then(res=>{
                 console.log(res);
                    this.fromData=res.data.data
                    this.fromData.types=JSON.parse(this.fromData.types)
                    this.fromData.coverUrl=JSON.parse(this.fromData.coverUrl)
                    this.fromData.resourceUrl=JSON.parse(this.fromData.resourceUrl)
                    this.$nextTick(()=>{
                        if(this.fromData.coverUrl){
                               this.$refs.audio.src = this.fromData.coverUrl.videoUrl
                        }
                     
                    })

        })
        },
        // 判断ios还是安卓
        osroan(){
        var ua = navigator.userAgent.toLowerCase()
        var agent = (navigator.userAgent || navigator.vendor || window.opera)
        if (agent != null) {
            var agentName = agent.toLowerCase()
            if (/iphone/i.test(agentName)) {
                // _this.isIOS = true // ios
                return 2
            } else if (/android/i.test(agentName)) {
                // _this.isAndroid = true //安卓
                return 1
            } else {
                return 1
            }
            }
        }
        // back(){
        //   this.$router.go(-1);//返回上一层
        // },
    },
    mounted() {

    },
}
</script>

<style lang='less' scoped> 
.osOrAndroid{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow-x: auto;
}
.box{
    height: 100%;
   
}
.container{
    width: 100vw;
    height: max-content;
    margin: 0 auto;
    background-color: #fff;
    // overflow-x: hidden;
    // overflow-y: auto;
    max-width: 1200px;
    .tittle{
        padding: 40px 0 45px 0;
        position: relative;
        .name{
            // width: 144px;
            // height: 34px;
            font-size: 36px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #000000;
            line-height: 36px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 40px;
            // width: 60%;
            max-width: 60%;
            white-space: nowrap;
            overflow: hidden;//超出隐藏
            text-overflow: ellipsis;//变成...
        }
        .back{
            margin-left:30px ;
            cursor: pointer;
        }

    }
    .game_introduce{
        padding:0 30px 57px 30px ;
        
        text-align: left;
        .introduce_title{
            height: 29px;
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #000000;
            line-height: 24px;
            margin-bottom: 25px;
        }
        .introduce_content{
            text-indent: 2rem;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 34px;

        }
    }
    .game_welfare{
        text-align: left;
        padding:0 30px 57px 30px ;
        
        .welfare_title{
        height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .welfare_content{
            // height: 25px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 34px;
            display: flex;
        }
    }
    .game_type{
        text-align: left;
        padding:0 30px 57px 30px ;
       
        .type_title{
        height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .type_content{
            // height: 25px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 34px;
            display: flex;
            flex-wrap: wrap;
        }
    }
    .game_size{
        text-align: left;
        padding:0 30px 57px 30px ;
        
        .size_title{
        height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .size_content{
            // height: 25px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 34px;
        }
    }
    .game_exclusive{
        text-align: left;
         padding:0 30px 57px 30px ;
        .exclusive_title{
        height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .exclusive_content{
            background: #EBEAEA;
            padding: 22px 30px;
            border-radius: 16px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 34px;
        }
    }
    .game_icon{
        text-align: left;
        padding:0 30px 57px 30px ;

        .icon_title{
            height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .icon_content{
             &>img{
                width: 183px;
                height: 183px;
                border-radius: 41px;
            }
        }
    }
    .game_video{
        text-align: left;
        padding:0 30px 57px 30px ;

        .video_title{
            height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .video_content{
                // border-radius: 16px;
                // overflow: hidden;

            &>div{
                width: 550px;
                height: 305px;
                border-radius: 16px;
                // overflow: hidden;
                 &>video{
                width: 100%;
                height: 100%;
                 object-fit: fill;
                border-radius: 16px;
                overflow: hidden;

                &:focus{
                    outline: none;
                }
            }
            }
            
        }
    }
    .game_screenshot{
        text-align: left;
        padding:0 29px 57px 30px ;
        
        // background: pink;
        .screenshot_title{
            height: 29px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin-bottom: 25px;
        }
        .screenshot_content{
             &>ul{
                display: flex;
                flex-wrap: wrap;
                max-width: 750px;
                // justify-content: space-between;
                &>li{
                    width: 213px;
                    height: 377px;
                    background: #1C677A;
                    margin: 0 26px 26px 0;
                    border-radius: 10px;
                    &>img{
                        width: 100%;
                        height: 100%;
                        border-radius: 10px;
                    }

                }
                &>li:nth-child(3n+3){
                    margin-right: 0;
                }

            }
             ul:after {
                content: "";
                width: 30%;
                height: 0px;
                visibility: hidden;
                 }
        }
    }
}
</style>